import { withPackingInstructions } from "./withPackingInstructions";
import withUpsells from "./withUpsells";

export { withPackingInstructions, withUpsells };
export default {
  withPackingInstructions,
  withUpsells,
};
